<div
	*ngIf="
		ratings?.branchRating?.overAllRating != 0 ||
		ratings?.appointmentRatingDetails?.length
	"
	class="lg:flex"
>
	<div
		class="p-24px bg-off-white rounded-12px lg:min-w-[320px] lg:mr-12px max-mobile:mb-margin-mobile-14 text-center max-h-[380px]"
	>
		<!-- DATE & EMAIL -->
		<section>
			<div class="rounded-6px text-center">
				<p
					class="text-dark-grey text-[60px] max-mobile:text-[36px] font-Poppins-bold mt-2 h-[50px] my-auto"
				>
					{{ ratings?.branchRating?.overAllRating | number : '0.1-1' }}
				</p>
				<div class="relative w-[115px] m-auto">
					<span class="stars-container w-[115px] text-[#d9dbe9]">★★★★★</span>
					<span
						[style]="
							'width :' + ratings?.branchRating?.overAllRating * 100 + '%'
						"
						class="stars-container w-[115px] absolute top-0 left-0 inline-block overflow-hidden text-[#ffce31]"
						>★★★★★</span
					>
				</div>

				<p class="text-font-16 text-medium-gray">
					{{ ratings?.branchRating?.clientCounts }}
					{{ 'RATINGS.RATINGS' | translate }}
				</p>
				<div
					class="flex justify-between"
					*ngFor="let bar of ratings?.ratingStarsDto"
				>
					<p
						class="mx-1 me-2 text-font-16 text-dark-grey whitespace-nowrap leading-[24px]"
					>
						{{ bar?.starNumber }} {{ 'RATINGS.STARS' | translate }}
					</p>
					<div class="progress-bar mt-3">
						<div [ngStyle]="getProgressBarStyles(bar?.percentage)"></div>
					</div>
					<p class="ms-3 mt-1 text-[#4E4B66] text-font-16">
						{{ bar?.ratingcount }}
					</p>
				</div>
			</div>
		</section>
	</div>
	<!-- STATISTICS&TABLE -->
	<div class="p-24px rounded-12px bg-off-white grow">
		<section>
			<div
				*ngFor="
					let rate of ratings?.appointmentRatingDetails
						| paginate
							: {
									itemsPerPage: ratingFilter?.paging?.pageSize,
									currentPage: ratingFilter?.paging?.pageNumber,
									totalItems: totalCount
							  }
				"
				class="p-[16px] border-[1px] border-[#D9DBE9] rounded-12px mb-2"
			>
				<div class="flex justify-between">
					<div class="flex">
						<img
							[src]="imagePath + rate?.clientImageUrl"
							alt=""
							srcset=""
							class="w-[40px] h-[40px] rounded-full me-2"
						/>

						<div>
							<p class="mb-0 text-[#4E4B66] font-DIN-Bold font-bold">
								{{ rate?.clientName }}
							</p>
							<div class="flex">
								<div class="flex items-center space-x-1 justify-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="17"
										viewBox="0 0 17 17"
									>
										<path
											d="M16.875 6.24375H10.4344L8.4375 0L6.44062 6.24375H0L5.20312 10.0969L3.23438 16.3125L8.4375 12.4594L13.6406 16.3125L11.6438 10.0687L16.875 6.24375Z"
											[ngClass]="
												rate.rating == 1 ||
												rate.rating == 2 ||
												rate.rating == 3 ||
												rate.rating == 4 ||
												rate.rating == 5
													? 'fill-svg'
													: 'nfill-svg'
											"
										/>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="17"
										viewBox="0 0 17 17"
									>
										<path
											d="M16.875 6.24375H10.4344L8.4375 0L6.44062 6.24375H0L5.20312 10.0969L3.23438 16.3125L8.4375 12.4594L13.6406 16.3125L11.6438 10.0687L16.875 6.24375Z"
											[ngClass]="
												rate.rating == 2 ||
												rate.rating == 3 ||
												rate.rating == 4 ||
												rate.rating == 5
													? 'fill-svg'
													: 'nfill-svg'
											"
										/>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="17"
										viewBox="0 0 17 17"
									>
										<path
											d="M16.875 6.24375H10.4344L8.4375 0L6.44062 6.24375H0L5.20312 10.0969L3.23438 16.3125L8.4375 12.4594L13.6406 16.3125L11.6438 10.0687L16.875 6.24375Z"
											[ngClass]="
												rate.rating == 3 || rate.rating == 4 || rate.rating == 5
													? 'fill-svg'
													: 'nfill-svg'
											"
										/>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="17"
									>
										<path
											d="M16.875 6.24375H10.4344L8.4375 0L6.44062 6.24375H0L5.20312 10.0969L3.23438 16.3125L8.4375 12.4594L13.6406 16.3125L11.6438 10.0687L16.875 6.24375Z"
											[ngClass]="
												rate.rating == 4 || rate.rating == 5
													? 'fill-svg'
													: 'nfill-svg'
											"
										/>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="17"
										viewBox="0 0 17 17"
									>
										<path
											d="M16.875 6.24375H10.4344L8.4375 0L6.44062 6.24375H0L5.20312 10.0969L3.23438 16.3125L8.4375 12.4594L13.6406 16.3125L11.6438 10.0687L16.875 6.24375Z"
											[ngClass]="rate.rating == 5 ? 'fill-svg' : 'nfill-svg'"
										/>
									</svg>
								</div>
								<p class="mx-2 text-[#4E4B66] mt-3 text-font-12">
									{{ rate?.rating }}
								</p>
							</div>
						</div>
					</div>
					<div class="flex" *ngIf="!rate?.hideComment">
						<p class="mx-2 text-[12px] text-medium-gray text-font-12">
							<span>{{
								rate?.ratingDate | timeAgo : translate.currentLang
							}}</span>
						</p>
						<a (click)="updateStatus(rate?.id)">
							<img
								src="assets/images/view.svg"
								class="h-[24px] cursor-pointer"
								alt=""
								srcset=""
							/>
						</a>
					</div>

					<div class="flex" *ngIf="rate?.hideComment">
						<span
							class="w-[5px] mx-1 h-[5px] mt-[7px] bg-[#B3261E] rounded inline-block align-middle"
						></span>
						<span class="text-[#B3261E]">{{
							'RATINGS.HIDDEN' | translate
						}}</span>
					</div>
				</div>
				<p
					class="mt-[10px] text-font-14 text-[#6E7191] {{
						rate?.hideComment ? 'opacity-30' : ''
					}} "
				>
					{{ rate?.comment }}
				</p>
			</div>

			<div class="mt-8 py-5 max-mobile:overflow-auto">
				<app-pagination
					[totalCount]="totalCount"
					[pageNumber]="ratingFilter.paging.pageNumber"
					(currentPage)="pageChanged($event, ratingFilter.paging.pageSize)"
					(itemsCountPerPage)="pageChanged(1, $event)"
				></app-pagination>
			</div>
		</section>
	</div>
</div>
<div
	*ngIf="
		ratings?.branchRating?.overAllRating == 0 &&
		!ratings?.appointmentRatingDetails?.length
	"
	class="text-center m-auto mt-[130px] max-mobile:mt-[60px]"
>
	<img
		src="assets/images/star-slash.svg"
		class="m-auto mt-12px pb-[10px]"
		alt=""
		srcset=""
	/>
	<p class="text-[#4E4B66] text-font-16">
		{{ 'RATINGS.NO_RATINGS_YET' | translate }}
	</p>
</div>
